import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import { SHOP } from "@/constants";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-forest pt-20 text-cream">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid grid-cols-1 gap-12 border-b border-cream/10 pb-16 md:grid-cols-12">
          <div className="md:col-span-5">
            <p className="font-serif text-5xl font-medium italic md:text-6xl">Utsav Flowers</p>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-cream/60">
              Dibrugarh's oldest flower house. Fresh cut flowers, bouquets,
              artificials, gifts and event décor — since 1999.
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="mb-5 text-[10px] font-bold uppercase tracking-[0.25em] text-cream/40">Explore</p>
            <div className="flex flex-col gap-3">
              <Link to="/shop" data-testid="footer-link-shop" className="text-sm text-cream/70 transition-colors hover:text-marigold">The Collection</Link>
              <button onClick={() => scrollToId("#decorations")} data-testid="footer-link-decor" className="text-left text-sm text-cream/70 transition-colors hover:text-marigold">Event Décor</button>
              <button onClick={() => scrollToId("#gallery")} data-testid="footer-link-gallery" className="text-left text-sm text-cream/70 transition-colors hover:text-marigold">Gallery</button>
              <button onClick={() => scrollToId("#contact")} data-testid="footer-link-contact" className="text-left text-sm text-cream/70 transition-colors hover:text-marigold">Contact</button>
            </div>
          </div>
          <div className="md:col-span-4">
            <p className="mb-5 text-[10px] font-bold uppercase tracking-[0.25em] text-cream/40">Visit Us</p>
            <p className="text-sm leading-relaxed text-cream/70">{SHOP.address}</p>
            <a href={`tel:${SHOP.phoneLink}`} data-testid="footer-phone-link" className="mt-2 block text-sm text-cream/70 transition-colors hover:text-marigold">
              {SHOP.phoneDisplay}
            </a>
            <p className="mt-2 text-sm text-cream/70">{SHOP.hours}</p>
            <p className="mb-3 mt-8 text-[10px] font-bold uppercase tracking-[0.25em] text-cream/40">Follow Us</p>
            <div className="flex flex-col gap-3">
              <a
                href="https://instagram.com/utsavflowerboutique"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-boutique"
                className="flex items-center gap-2 text-sm text-cream/70 transition-colors hover:text-marigold"
              >
                <Instagram size={15} /> Utsav Flower Boutique
              </a>
              <a
                href="https://instagram.com/utsavdecorators"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-decorators"
                className="flex items-center gap-2 text-sm text-cream/70 transition-colors hover:text-marigold"
              >
                <Instagram size={15} /> Utsav Decorators
              </a>
            </div>
          </div>
        </div>
        <p
          aria-hidden
          className="select-none py-8 text-center font-serif text-[16vw] italic leading-none text-cream/[0.05]"
        >
          since 1999
        </p>
        <div className="flex flex-col items-center justify-between gap-3 border-t border-cream/10 py-6 text-[10px] font-bold uppercase tracking-[0.2em] text-cream/40 md:flex-row">
          <span>© 2026 Utsav Flowers · Dibrugarh, Assam</span>
          <span data-testid="footer-tagline">Blooming since 1999</span>
        </div>
      </div>
    </footer>
  );
}
